import Title from '../../microComponents/elements/Title';
import ComponentCard from '../../microComponents/elements/ComponentCard';
import logo from '../../../images/logo2.svg';
import {FaInternetExplorer, FaPhone} from "react-icons/fa";
import {AiFillInstagram} from "react-icons/ai";
import { MdInstallMobile } from "react-icons/md";

const Faq = () => {


    return (<div>
            <ComponentCard>
                <div className='flex justify-between'>
                    <Title>سوالات متداول</Title>

                </div>
            </ComponentCard> <ComponentCard>
            <div className="flex justify-center items-center flex-col">

                <img className='w-72  ' src={logo} alt=""/>
                <div className="flex mt-6 gap-2 items-center">

                    <a href="https://iotfig.com" target='_blank'  rel="noreferrer" >
                        www.iotfig.com
                    </a><FaInternetExplorer size={22}/>

                </div>
                <div className="flex mt-6 gap-2 items-center">

                    <a href="tel:02166781347">
                        021-66781347
                    </a>
                    <FaPhone size={22}/>
                </div>
                <div className="flex mt-6 gap-2 items-center">

                    <a href="https://alvand.iotfig.com/apk/iotfig.apk">
                         دانلود اپلیکیشن
                    </a>
                    <MdInstallMobile size={22}/>
                </div>
				<div className="flex mt-6 gap-2 items-center">

                    <a href="https://www.instagram.com/iotfig/?hl=en">
                        iotfig
                    </a>
                    <AiFillInstagram size={22}/>
                </div>
				


            </div>

        </ComponentCard></div>
    );
};


export default Faq;